import LandingPageBasicInfo from "./landing-page-basic-info";
import IconLocation from "../../images/icons/icon-location.png";
import RegaLogo from "../../assets/rega-logo.png";
import DocumentTitle from "../actions/DocumentTitle";
import IconAppStore from "../images/icon-app-store-white.png";
import IconGooglePlay from "../images/icon-google-store-white.png";

type Props = {
  Landingpage?: any;
};

const LandingPageContent = (props: Props) => {
  const { Landingpage } = props;
  DocumentTitle(`${Landingpage?.Name_ar}`);
  const IosDownloadLink = Landingpage?.landing_page?.ios_download_link !== null ? Landingpage?.landing_page?.ios_download_link :
    "https://app.adjust.com/1pvuhxfy?engagement_type=fallback_click",
    AndroidDownloadLink = Landingpage?.landing_page?.android_download_link !== null ? Landingpage?.landing_page?.android_download_link :
      "https://app.adjust.com/1pe80cxa?engagement_type=fallback_click";

  return (
    <div className="landing-page__content">
      <div className="landing-page__content__top">
        <div className="landing-page__content__top__row">
          {Landingpage.property_types.length > 0 && (
            <div className="build-status">
              {Landingpage.property_types.map((property: any, index: any) => (
                <span className="text" key={index}>
                  {property.Name_ar}{" "}
                  {index < Landingpage.property_types.length - 1 && "،"}
                </span>
              ))}
            </div>
          )}
          {/*Landingpage?.is_selling_on_map === true && (
            <div className="build-status">
              <span className="text">بيع على الخارطة</span>
            </div>
          )*/}
        </div>
        <h3 className="title">{Landingpage?.landing_page?.ProjectName}</h3>
        <span className="location">
          <img src={IconLocation} alt="" className="icon-location" />
          <span className="text">
            {Landingpage?.City?.Name_ar} / {Landingpage?.Neighbourhood?.Name_ar}
          </span>
        </span>
      </div>
      {Landingpage.project_details.length > 0 && (
        <LandingPageBasicInfo projectDetails={Landingpage.project_details} />
      )}
      {Landingpage?.is_selling_on_map === true && (
        <div className="landing-page__content__brind">
          <img src={RegaLogo} alt="" />
          <div className="text">
            <span className="des">
              رخصة البيع والتأجير على الخارطة
            </span>
            <span className="number">
              {Landingpage?.Wafi_Agreement_Number}
            </span>

          </div>
        </div>
      )}
      <div className="landing-page__content__app-story">


        <h3>
          حمل التطبيق لاستعراض العقارات
        </h3>
        <div className="list">
          <a
            href={IosDownloadLink}
            target="_blank"
            rel="noreferrer"
          >
            <img src={IconAppStore} alt="app store" />
          </a>
          <a
            href={AndroidDownloadLink}
            target="_blank"
            rel="noreferrer"
          >
            <img src={IconGooglePlay} alt="app store" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default LandingPageContent;
